import { css } from 'styled-components';
import { SCREEN_SIZE } from '../../grid';
export const GlobalFontSizes = css `
    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        font-size: 12px;
    }

    @media (max-width: ${SCREEN_SIZE.TABLET.max}) {
        font-size: 14px;
    }

    @media (max-width: ${SCREEN_SIZE.DESKTOP.max}) {
        font-size: 16px;
    }

    @media (max-width: ${SCREEN_SIZE.DESKTOP_HD.max}) {
        font-size: 16px;
    }
`;
//# sourceMappingURL=font-sizes.js.map